import React, { useState, useEffect, useRef } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { auditByStatusByDateOptions } from "../../../graphql/audit/custom-queries";
import { inboundShipmentByStateByRailcarReduced } from "../../../graphql/inbound/custom-queries";
import { outboundShipmentByStatusOptions } from "../../../graphql/outbound/custom-queries";

import { userByActiveByLastName } from "../../../graphql/queries";
import { updateAuditAssignee } from "../../../graphql/audit/custom-mutations";
import { performUpdateInboundMini } from "../../../graphql/inbound/inboundCRUD";
import { performUpdateOutboundMini } from "../../../graphql/outbound/outboundCRUD";

import {
  Create,
  DateInput,
  FileInput,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
  required,
  SelectInput,
  useRedirect,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import {
  addBusinessDays,
  isFuture,
  isToday,
  format,
  isAfter,
  parse,
} from "date-fns";

import {
  ACCEPTED_FILES,
  AuditStatus,
  FilePaths,
  MAX_FILES,
  OutboundStatus,
  Priorities,
  TaskType,
  TaskTypes,
} from "../../../utils/constants";
import { logError } from "../../../utils/appUtils";
import { BackButton } from "../../../components/common/BackButton";
import { FileField } from "../../../components/common/FileField";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { TaskCreateHelp } from "./TaskHelp";
import { TaskAside } from "./TaskAside";

import { Box } from "@material-ui/core";
import { AttachFileIcon } from "../../../components/common/iconography";
import { handleFileChange, saveRemoveFiles } from "../../../utils/fileUtils";

const isTodayOrFutureDate =
  (message = "Date must be in the future") =>
  (value) => {
    const date = parse(value, "yyyy-MM-dd", new Date());
    return value && (isToday(date) || isFuture(date)) ? undefined : message;
  };

const validateCreate = ({ dueDate, lateDate }) => {
  const errors = {};
  const due = parse(dueDate, "yyyy-MM-dd", new Date());
  const late = parse(lateDate, "yyyy-MM-dd", new Date());

  if (isAfter(due, late)) {
    debugger;
    errors.lateDate = ["Late date must be greater then due date"];
  }
  return errors;
};

const TaskCreateForm = ({
  setLink,
  userOptions,
  referenceOptions,
  setReferenceOptions,
  notify,
  ...props
}) => {
  const form = useForm();
  const [category, setCategory] = useState();

  const getShipments = async () => {
    try {
      const response = await API.graphql(
        graphqlOperation(inboundShipmentByStateByRailcarReduced, {
          reloadYardId: window.appUser?.reloadYardId,
          stateRailCarNumber: { beginsWith: { state: "PROCESS" } },
        }),
      );
      debugger;
      if (response.data.inboundShipmentByStateByRailcar.items.length > 0) {
        const placedShipmentsRes =
          response.data.inboundShipmentByStateByRailcar.items;
        let shipmentsOptions = placedShipmentsRes.map((itm) => ({
          id: itm.id,
          name:
            itm.railCarNumber +
            " - " +
            itm.accountName +
            (itm.assignedTo ? " - " + itm.assignedTo : ""),
          reloadYardId: itm.reloadYardId,
          status: itm.status,
          state: itm.state,
          railCarNumber: itm.railCarNumber,
          accountName: itm.accountName,
          releaseDateTime: itm.releaseDateTime,
          placedDateTime: itm.placedDateTime,
          notifyDateTime: itm.notifyDateTime,
          scheduledDateTime: itm.scheduledDateTime,
          createDateTime: itm.createDateTime,
          accountId: itm.accountId,
        }));
        setReferenceOptions(shipmentsOptions);
      } else {
        notify("Couldn't find placed Inbound Shipments", "warning");
      }
    } catch (error) {
      logError("tasks:TaskCreate:Task:getShipments", error, notify);
    }
  };

  const getOutboundShipments = async () => {
    try {
      // In-yard shipments: ARRIVED (at the gate) and PLACED (spotted). The
      // GSI takes one status per query.
      const responses = await Promise.all(
        [OutboundStatus.ARRIVED, OutboundStatus.PLACED].map((status) =>
          API.graphql(
            graphqlOperation(outboundShipmentByStatusOptions, {
              reloadYardId: window.appUser?.reloadYardId,
              status: { eq: status },
            }),
          ),
        ),
      );
      const items = responses.flatMap(
        (response) => response.data.outboundShipmentByStatus.items,
      );
      if (items.length > 0) {
        const data = items.sort((a, b) => {
          const first = a.arrivalDateTime
            ? new Date(a.arrivalDateTime)
            : Date.now();
          const second = b.arrivalDateTime
            ? new Date(b.arrivalDateTime)
            : Date.now();
          return first - second;
        });

        let shipmentsOptions = data.map((itm) => ({
          id: itm.id,
          name:
            itm.pickupNumber +
            " - " +
            itm.accountName +
            (itm.assignedTo ? " - " + itm.assignedTo : ""),
          poNumber: itm.poNumber,
          pickupNumber: itm.pickupNumber,
          accountName: itm.accountName,
          reloadYardId: itm.reloadYardId,
          status: itm.status,
          active: itm.active,
          endDateTime: itm.endDateTime,
          arrivalDateTime: itm.arrivalDateTime,
          scheduledDateTime: itm.scheduledDateTime,
          createDateTime: itm.createDateTime,
        }));
        setReferenceOptions(shipmentsOptions);
      } else {
        notify("Couldn't find placed Outbound Shipments", "warning");
      }
    } catch (error) {
      logError("tasks:TaskCreate:Task:getOutboundShipments", error, notify);
    }
  };

  const getAudit = async () => {
    try {
      debugger;
      const response = await API.graphql(
        graphqlOperation(auditByStatusByDateOptions, {
          reloadYardId: window.appUser?.reloadYardId,
          sortDirection: "DESC",
          statusCreateDateTime: {
            beginsWith: { status: AuditStatus.IN_PROGRESS },
          },
        }),
      );
      debugger;
      const activeAudits = response.data.auditByStatusByDate.items;
      if (activeAudits.length > 0) {
        let auditOptions = activeAudits.map((itm) => ({
          id: itm.id,
          name:
            format(new Date(itm.createDateTime), "MM-dd-yyyy") +
            " - " +
            itm.accountName +
            (itm.assignedTo ? " - " + itm.assignedTo : ""),
          status: itm.status,
          accountName: itm.accountName,
          createDateTime: itm.createDateTime,
        }));
        setReferenceOptions(auditOptions);
        debugger;
      } else {
        setLink(null);
        notify("Couldn't find active Audits", "warning");
      }
    } catch (error) {
      logError("tasks:TaskCreate:Task:getAudit", error, notify);
      debugger;
    }
  };

  const showOptions = () => {
    return (
      referenceOptions?.length > 0 &&
      (category === TaskType.AUDIT ||
        category === TaskType.ACCEPT_SHIPMENT ||
        category === TaskType.PROCESS_OUTBOUND_SHIPMENT)
    );
  };

  const handleCategory = (evt) => {
    const value = evt.target.value;
    setReferenceOptions([]);
    setLink(null);
    setCategory(value);
    // Clear any reference/name carried over from the previous task type.
    // Otherwise a stale reference id survives the switch (and still passes
    // required() because it's truthy), and transform() fires an update
    // mutation with a null shipment/audit id.
    form.change("reference", undefined);
    form.change("name", undefined);
    if (value === TaskType.ACCEPT_SHIPMENT) {
      getShipments();
    } else if (value === TaskType.AUDIT) {
      getAudit();
    } else if (value === TaskType.PROCESS_OUTBOUND_SHIPMENT) {
      getOutboundShipments();
    } else if (value === TaskType.CAPACITY_UTILIZATION) {
      setLink("/utilization");
      const taskName = "Update capacity utilization";
      form.change("name", taskName);
    }
  };

  const handleReference = (evt) => {
    debugger;
    const value = evt.target.value;
    const referencedObject = referenceOptions.find((itm) => itm.id === value);

    if (category === TaskType.AUDIT) {
      setLink("/processAudit/" + value);
      const taskName = "Audit: " + referencedObject.name;
      form.change("name", taskName);
    } else if (category === TaskType.ACCEPT_SHIPMENT) {
      setLink("/processShipments/" + value);
      const taskName = "Inbound: " + referencedObject.name;
      form.change("name", taskName);
    } else if (category === TaskType.PROCESS_OUTBOUND_SHIPMENT) {
      setLink("/processOutboundShipments/" + value);
      const taskName = "Outbound: " + referencedObject.name;
      form.change("name", taskName);
    } else {
      setLink(null);
    }
  };

  return (
    <Box flex={1} style={{ width: "100%" }}>
      <Box display={{ xs: "block", sm: "flex" }}>
        <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
          <SelectInput
            label="Task type"
            source="category"
            variant="outlined"
            fullWidth
            choices={TaskTypes}
            onChange={handleCategory}
            validate={required()}
          />
        </Box>
        <Box flex={1}>
          {showOptions() && (
            <SelectInput
              source="reference"
              label={category === TaskType.AUDIT ? "Audit" : "Shipment"}
              variant="outlined"
              fullWidth
              choices={referenceOptions}
              validate={required()}
              onChange={handleReference}
            />
          )}
        </Box>
      </Box>
      <Box display={{ xs: "block", sm: "flex" }}>
        <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
          <TextInput
            source="name"
            label="Task name"
            variant="outlined"
            fullWidth
            validate={required()}
          />
        </Box>
        <Box flex={1}>
          <SelectInput
            source="assignedTo"
            label="Assign To"
            variant="outlined"
            fullWidth
            choices={userOptions}
            validate={required()}
          />
        </Box>
      </Box>
      <TextInput
        source="description"
        label="Task description"
        variant="outlined"
        multiline
        minRows={2}
        fullWidth
      />
      <Box display={{ xs: "block", sm: "flex" }}>
        <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
          <DateInput
            source="dueDate"
            variant="outlined"
            fullWidth
            validate={isTodayOrFutureDate()}
          />
        </Box>
        <Box flex={1}>
          <DateInput
            source="lateDate"
            variant="outlined"
            fullWidth
            validate={isTodayOrFutureDate()}
          />
        </Box>
      </Box>
      <Box display={{ xs: "block", sm: "flex" }}>
        <Box flex={1}>
          <SelectInput
            source="priority"
            variant="outlined"
            fullWidth
            choices={Priorities}
          />
        </Box>
        <Box flex={1} mr={{ xs: 0, sm: "1em" }} />
      </Box>
      <Box display={{ xs: "block", sm: "flex" }}>
        <Box flex={1}>
          <FileInput
            source="attachments"
            label="ATTACHMENTS"
            variant="outlined"
            fullWidth
            placeholder={
              <p>
                <AttachFileIcon fontSize="large" /> <br /> Drop file(s) to
                upload, or click to select.
              </p>
            }
            accept={ACCEPTED_FILES}
            multiple
            maxFiles={MAX_FILES}
            options={{ maxFiles: MAX_FILES }}
            onChange={(value) =>
              handleFileChange("attachments", value, form, notify)
            }
          >
            <FileField source="src" title="title" target="_blank" />
          </FileInput>
        </Box>
      </Box>
    </Box>
  );
};

export const TaskCreate = (props) => {
  const notify = useNotify();
  const [referenceOptions, setReferenceOptions] = useState([]);
  const [link, setLink] = useState();
  const [userOptions, setUserOptions] = useState();
  const isComponentMounted = useRef(true);

  useEffect(() => {
    debugger;
    if (isComponentMounted) getUsers();
    return () => (isComponentMounted.current = false);
  }, []);

  const getUsers = async () => {
    try {
      const response = await API.graphql(
        graphqlOperation(userByActiveByLastName, {
          reloadYardId: window.appUser?.reloadYardId,
          activeLastName: { beginsWith: { active: "true" } },
        }),
      );
      debugger;
      if (response.data.userByActiveByLastName.items.length > 0) {
        const users = response.data.userByActiveByLastName.items;
        let userList = users.map((itm) => ({
          id: itm.id,
          name: itm.fullName,
          fullName: itm.fullName,
        }));
        debugger;
        setUserOptions(userList);
      } else {
        logError("tasks:TaskCreate:Task:getUsers:response", response, notify);
      }
    } catch (error) {
      logError("tasks:TaskCreate:Task:getUsers", error, notify);
    }
  };

  const defaultValues = () => ({
    dueDate: format(new Date(), "yyyy-MM-dd"),
    lateDate: format(addBusinessDays(new Date(), 1), "yyyy-MM-dd"),
    reloadYardId: window.appUser?.reloadYardId,
    category: TaskType.GENERIC,
    groups: window.appUser?.groups,
    status: "10",
    allowReassign: "false",
    priority: 1,
    link,
  });

  const TaskCreateActions = ({ basePath }) => (
    <TopToolbar>
      <HelpButton>
        <TaskCreateHelp {...props} />
      </HelpButton>
      <BackButton basePath={basePath} />
    </TopToolbar>
  );

  const TaskCreateToolbar = (props) => {
    const redirect = useRedirect();
    const { basePath } = props;

    const transform = async (data) => {
      debugger;
      data = { ...data };
      const { assignedTo, category, reference } = data;

      try {
        const user = userOptions.find((itm) => itm.id === assignedTo);
        data.assignedToName = user.fullName;

        if (category !== TaskType.GENERIC) {
          const referencedObject = {
            ...referenceOptions.find((itm) => itm.id === reference),
          };
          delete referencedObject.name;

          // Guard against a missing/stale reference. Without a valid id the
          // update mutations below send a null ID! and AppSync rejects the
          // whole save with a coerced-null error.
          if (!referencedObject?.id) {
            notify(
              "Please re-select the shipment/audit before saving.",
              "warning",
            );
            return Promise.reject(
              new Error(`Missing reference id for task category ${category}`),
            );
          }

          if (category === TaskType.AUDIT) {
            const toUpdateAudit = {
              id: referencedObject.id,
              assignedTo: user.fullName,
            };
            await API.graphql(
              graphqlOperation(updateAuditAssignee, { input: toUpdateAudit }),
            );
          } else if (category === TaskType.ACCEPT_SHIPMENT) {
            const toUpdateInboundShippment = {
              id: referencedObject.id,
              assignedTo: user.fullName,
            };
            await performUpdateInboundMini(toUpdateInboundShippment);
          } else if (category === TaskType.PROCESS_OUTBOUND_SHIPMENT) {
            const toUpdateOutboundShippment = {
              id: referencedObject.id,
              assignedTo: user.fullName,
            };
            await performUpdateOutboundMini(toUpdateOutboundShippment);
          }
        }

        debugger;
        if (data.attachments?.length > 0) {
          await saveRemoveFiles(
            undefined,
            data,
            "attachments",
            `${FilePaths.TASKS}/${data.id}`,
          );
        }
      } catch (error) {
        logError(
          "task:TaskCreate:TaskCreateToolbar:transform " + category,
          error,
          notify,
        );
        return Promise.reject(error);
      }

      return data;
    };

    const onSuccess = (data) => {
      notify("Task created successfully", "success");
      redirect(basePath);
    };

    const onFailure = (error) => {
      logError("task:TaskCreate:TaskCreateToolbar:onFailure", error, notify);
    };

    return (
      <Toolbar {...props}>
        <SaveButton
          disabled={props.pristine}
          transform={transform}
          onSuccess={onSuccess}
          onFailure={onFailure}
        />
      </Toolbar>
    );
  };

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Task" />}
      actions={<TaskCreateActions />}
      aside={<TaskAside />}
    >
      <SimpleForm
        initialValues={defaultValues()}
        validate={validateCreate}
        redirect="list"
        variant="outlined"
        toolbar={<TaskCreateToolbar />}
      >
        <TaskCreateForm
          setLink={setLink}
          userOptions={userOptions}
          referenceOptions={referenceOptions}
          setReferenceOptions={setReferenceOptions}
          notify={notify}
        />
      </SimpleForm>
    </Create>
  );
};
